<template>
  <div class="input-group">
    <label class="input-label" v-if="showLabel">{{ $t('labels.' + label) }}{{ isRequired ? ' *' : '' }}</label>
    <form-group
      :name="label"
      :validator="validator"
      label="label"
    >
      <template slot-scope="{ attrs }">
        <v-text-field
          :value="model"
          v-bind="attrs"
          :counter="counter"
          :maxlength="maxlength"
          :disabled="disabled"
          :append-icon="icon"
          @input="$emit('update:model', $event); validator.$touch();"
          @change="$emit('update:model', $event); validator.$touch();"
        />
      </template>
    </form-group>
  </div>
</template>

<script>
  export default {
    props: {
      model: {
        type: [Number, String],
        default: null,
        required: true
      },
      validator: {
        type: Object,
        default: function () {
          return {}
        },
        required: true
      },
      label: {
        type: String,
        default: ''
      },
      showLabel: {
        type: Boolean,
        default: true,
        required: false
      },
      asterix: {
        type: Boolean,
        default: null,
        required: false
      },
      maxlength: {
        type: Number,
        default: null,
        required: false
      },
      disabled: {
        type: Boolean,
        default: false,
        required: false
      },
      icon: {
        type: String,
        default: '',
        required: false
      }
    },
    computed: {
      isRequired () {
        if (this.asterix !== null) {
          return this.asterix
        } else {
          return typeof this.validator.$params.required !== 'undefined' && this.validator.$params.required !== null
        }
      },
      counter () {
        return this.maxlength !== null
      }
    }
  }
</script>
